import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { HygraphVisualization } from '@app/@shared/services/hygraph/hygraph.models';
import { VisualContentOptions } from 'amazon-quicksight-embedding-sdk/dist/index';
import { CustomOption, OptionGroup } from '../generic-toolbar/option-model';
import { StatelessBehavior } from '../generic-toolbar/state-behavior-model';
import { Icon } from '../generic-toolbar/icons';

@Component({
  selector: 'app-quicksight-visual-viewer',
  templateUrl: './quicksight-visual-viewer.component.html',
  styleUrl: './quicksight-visual-viewer.component.scss',
  standalone: false
})
export class QuicksightVisualViewerComponent implements AfterViewInit {

  @Input() visualization: HygraphVisualization;

  @ViewChild('VisualViewerContainer') visualViewerContainer: ElementRef;

  public toolbarOptions: OptionGroup[] = [];
  public visualContentOptions: VisualContentOptions = {};

  constructor() {}

  @HostListener('document:fullscreenchange') exitFullScreenHandler() {
    if (document.fullscreenElement === null) {
      this.toolbarOptions = this.createToolbarOptions();
    }
  }

  ngAfterViewInit(): void {
    this.toolbarOptions = this.createToolbarOptions();
  }

  public onClickToggleFullscreen(): void {
    if (document.fullscreenElement !== null) {
      document.exitFullscreen();
    } else {
      this.toolbarOptions = this.createFullScreenToolbarOption();
      this.visualViewerContainer.nativeElement.requestFullscreen();
    }
  }

  private createToolbarOptions(): OptionGroup[] {
    const optionGroups: OptionGroup[] = [];
    const zoomOptions: any[] = [];

    zoomOptions.push(
      new CustomOption(
        'toggle-fullscreen',
        { click: this.onClickToggleFullscreen.bind(this) },
        new StatelessBehavior(Icon.IMAGE_ENTER_FULLSCREEN, 'Full Screen')
      )
    );

    optionGroups.push(new OptionGroup(zoomOptions));
    return optionGroups;
  }

  private createFullScreenToolbarOption(): OptionGroup[] {
    return [
      new OptionGroup([
        new CustomOption(
          'toggle-fullscreen',
          { click: this.onClickToggleFullscreen.bind(this) },
          new StatelessBehavior(Icon.IMAGE_EXIT_FULLSCREEN, 'Exit Full Screen')
        )
      ])
    ];
  }
}
